import React, { useEffect, useState } from "react";
import ModalDialog from '@atlaskit/modal-dialog';
import Footer from './footer';
import { messages, stripeMessage } from "../welcome-dashboard/messages";
import { getLJsonStorage } from "../welcome-dashboard/Utils";
import { createConnectLink } from "../welcome-dashboard/Request.d";
import { hideApiLoader, setIsClaimClicked, showApiLoader } from "../redux/tool-webjam/actions";
import toast from "react-simple-toasts";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { FEATURE_CUSTOM_REDUX } from "../constant";
import { setStripeRequesting } from "../redux/tool-webjam-v2/actions";
import { connectAccountFlag } from "../Utils";
import { Constant } from "../../webjam/constant";
import Dialog from "../../base/ui/components/web/Dialog";
import { ct, dynamicMessageLocale } from "../constant-Utils";

const PaymentAccountModal = (props) => {

    const dispatch = useDispatch();
    const [isHide, setIsHide] = useState(false);
    var submitText = ct("rta-trmc.dialogs.create");

    const [accountStatus, setAccountStatus] = useState({
        hasConnect: false,
        verifyStatus: ct("rta-trmc.dialogs.create")
    })

    const userLoginData = useSelector(state => state[FEATURE_CUSTOM_REDUX].userLoginData);

    useEffect(() => {
        // let hasConnect = getLJsonStorage("auth", "stripe_account_id");
        // let hasVerified = getLJsonStorage("auth", "connectVerified");
        let hasConnect = userLoginData?.user?.stripe_account_id;
        let hasVerified = userLoginData?.user?.connectVerified;
        if (hasConnect) {
            setAccountStatus({
                hasConnect: true,
                verifyStatus: hasVerified || "create"
            })

            if (hasVerified == connectAccountFlag.PENDING || hasVerified == connectAccountFlag.FAILED) {
                setIsHide(true)
            }
        }
    }, [userLoginData?.user?.connectVerified])


    const handleAccountLink = () => {
        dispatch(showApiLoader());
        if (props.changePopupState) {
            // props.changePopupState("")
        }
        let popUid = uuidv4()
        let user_id = userLoginData?.user?.id;
        dispatch(setStripeRequesting(true))
        createConnectLink(user_id, popUid)
            .then(async resp => {
                dispatch(hideApiLoader())
                if (resp.status == 1) {
                    let redir = resp.data?.data?.link;
                    if (redir) {
                        var win = window.open(redir);
                        if (props.stripeSession) {
                            props.stripeSession({
                                uid: popUid,
                                win
                            })
                        }
                    } else {
                        toast(ct("rta-trmc.dashboard.subscription.failed"), Constant.App.ToastTime.LongCloseTime)
                    }
                } else {
                    let msg = await dynamicMessageLocale(resp?.message);
                    toast(msg, Constant.App.ToastTime.LongCloseTime)
                }
            })
    }

    const onSubmit = () => {
        if (accountStatus?.verifyStatus?.toLowerCase() == "create" || accountStatus?.verifyStatus?.toLowerCase() == connectAccountFlag.FAILED) {
            handleAccountLink()
        }
        // if (props.changePopupState) {
        //     props.changePopupState("")
        // }

    }

    const onClose = () => {
        console.log("Handle submit")
        const paymentStatus = userLoginData?.user?.connectVerified;
        if (paymentStatus == connectAccountFlag.ENABLED || paymentStatus == connectAccountFlag.PENDING) {
            dispatch(setIsClaimClicked(true));
        }
        if (props.changePopupState) {
            props.changePopupState("")
        }
    }

    const renderMessage = () => {
        if (props.defaultMessage) {
            submitText = ct("rta-trmc.dialogs.create")
            return ct("stripeMessage.paymentAccountCreate", "stripeMessage");
        } else if (accountStatus.hasConnect) {
            if (accountStatus.verifyStatus == connectAccountFlag.PENDING) {
                return ct("stripeMessage.paymentAccountVerification", "stripeMessage");
            } else if (accountStatus.verifyStatus == connectAccountFlag.FAILED) {
                submitText = ct("rta-trmc.dialogs.update")

                return <>
                    <b>{ct("rta-trmc.dashboard.myRoom.error")}: </b>{ct("stripeMessage.paymentAccountFailed", "stripeMessage")}
                    <span
                        style={{
                            color: "var(--theme-primary-color)",
                            cursor: "pointer"
                        }}
                        onClick={() => handleAccountLink()}
                    ><br /> {ct("rta-trmc.dashboard.myRoom.clickHere")} </span> {ct("rta-trmc.dialogs.toUpdateAcc")}

                </>;
            } else if (accountStatus.verifyStatus == connectAccountFlag.ENABLED) {
                return ct("stripeMessage.enabledAccount", "stripeMessage");
            } else if (accountStatus.verifyStatus == connectAccountFlag.APPROVED) {
                return ct("stripeMessage.approvedAccount", "stripeMessage");
            }
        } else {
            submitText = ct("rta-trmc.dialogs.create")
            return ct("stripeMessage.paymentAccountCreate", "stripeMessage");
        }
    }

    return (<>
        <Dialog
            disableAutoHideOnSubmit={true}
            disableBackdropClose={true}
            hideCloseButton={true}
            onCancel={props?.onClose || onClose}
            onSubmit={props?.onSubmit || onSubmit}
            cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall") }}
            ok={{ translationKey: ct("rta-trmc.dialogs.create") }}
            titleKey={ct("rta-trmc.dialogs.setupPaymentAcc")}
            rtaClassName="setup-payment-account-modal-wrapper"
            testId={"setup-payment"}
        >
            {/* <ModalDialog
            heading="Setup Payment Account"
            testId={"setup-payment"}
            components={{
                Footer: () => <Footer
                    text={submitText}
                    isHide={isHide}
                    className={isHide ? "flex-row-reverse" : ""}
                    onSubmit={props?.onSubmit || onSubmit}
                    onClose={props?.onClose || onClose}
                    showKeyline={false} />,
                Container: 'div',
            }}
        > */}
            <p style={{
                color: "#333"
            }}>
                <>{renderMessage()}</>
            </p>
            {/* </ModalDialog> */}
        </Dialog>
    </>)
}


export default PaymentAccountModal;